import * as intl from "react-intl-universal";
import Selector from './Selector';
import locales from './locales';
import languages, { LangLocale, Language as LanguageType } from './utils/languages';
import mergeLocales from './utils/mergeLocales';
// tips: 一级分类key保留字段：Locales

export type Language = LanguageType;

export {
    LangLocale, Selector, languages, locales, mergeLocales
};

export default class I18n {
    static get storage() {
        return languages.get();
    }

    // 用户浏览器系统的默认语言
    static get browser() {
        return window.navigator.language;
    }

    // 带query参数url
    static get query() {
        return languages.getQuery();
    }

    // 默认语言（英语）
    static get initial() {
        return languages.getInitial();
    }

    // 获取国际化语言类型
    static get lang() {
        return languages.isSupported(I18n.query || I18n.storage || I18n.browser);
    }

    // ip 地址识别
    static ipConfig = (country: string, region?: string) => {
        return languages.ip(country, region);
    };

    // 初始化
    static init = async (language: Language, userLocales: any = {}, languaeConfig: any = {}) => {
        languages.init(languaeConfig);
        await languages.set(language, false);
        await intl.init({
            locales: userLocales,
            currentLocale: language,
        });
    };
}
